import { baseApi, client } from '../baseApi.ts';

export const templateEndpoints = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		list: builder.query({
			// @ts-ignore
			queryFn: async (type) => {
				try {
					const response = await client.assets.templates({ type });
					return { data: response.data };
				} catch (error) {
					return { error };
				}
			},
			providesTags: ['Templates'],
		}),
	}),
});
